"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * We have our own version of IconPath difference from cw-ui
 * in case we decide to lock to a specific version of icons that
 * is different than cw-widget's icon version
 */
var IconPath = function () {
  function IconPath() {
    (0, _classCallCheck3.default)(this, IconPath);
  }

  (0, _createClass3.default)(IconPath, null, [{
    key: "get",

    /**
     * Gets full path for SVG icon from S3 bucket hosted in https://files.connectwise.com
     * 
     * @static
     * @param {string} icon 
     * @param {boolean} isSvg
     * @returns {string}
     * @memberof IconPath
     */
    value: function get(icon) {
      var isSvg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (isSvg) {
        return "https://files.connectwise.com/UI/Icons/v1.0/" + icon + ".svg";
      } else {
        return "https://files.connectwise.com/UI/Icons/v1.0/" + icon;
      }
    }
  }]);
  return IconPath;
}();

exports.default = IconPath;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/IconPath.js
// module id = 82
// module chunks = 10